import { render, staticRenderFns } from "./MagazzinoArticoliStoricoGiacenzeComponent.vue?vue&type=template&id=493ebd94"
import script from "./MagazzinoArticoliStoricoGiacenzeComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliStoricoGiacenzeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports